module.exports = __webpack_public_path__ + "img/Headshot.fcb5f695.jpg";